import * as _ from "lodash";
import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface IReportDefinition {
    ID: number;
    Name: string;
    FileName: string;
    FolderName: string;
    FileKey: string;
    EmailSubjectTemplate: string;
    IsActive: boolean;
}

export interface IReportTreeItem {
    text: string;
    spriteCssClass?: string;
    expanded?: boolean;
    items: IReportTreeItem[];
    report?: IReportDefinition;
}

export interface IEmailReportRequest {
    EmailAddresses: string[];
    ReportID: string;
    Parameters: IReportParameter[];
}

export interface IReportParameter {
    Name: string;
    Value: string;
}

export function CreateReportTreeDataSource(reports: IReportDefinition[]): IReportTreeItem[] {
    const treeItems: IReportTreeItem[] = [];
    const reportsAtRoot: IReportTreeItem[] = [];

    for (const report of reports) {

        // Put the reports with no folder at the bottom of the list
        if (report.FolderName === "") {
            reportsAtRoot.push({ text: report.Name, report, items: [], spriteCssClass: "fa fa-file-text-o" });
            continue;
        }

        let folderItem = _.find(treeItems, (value): boolean => {
            return value.text === report.FolderName;
        });

        if (!folderItem) {
            folderItem = { text: report.FolderName, items: [], expanded: true };
            treeItems.push(folderItem);
        }

        folderItem.items.push({ text: report.Name, report, items: [], spriteCssClass: "fa fa-file-text-o" });
    }

    treeItems.push(...reportsAtRoot);

    return treeItems;
}

export function GetAllReports(): JQueryDeferred<Data.IResponse<IReportDefinition[]>> {
    const url: string = "/api/Report/GetAll";
    return Util.callWebService(url, "GET");
}

export function SaveReport(report: IReportDefinition): JQueryDeferred<Data.IResponse<number>> {
    const url: string = "/api/Report/Save";
    return Util.callWebService(url, "POST", report);
}

export function EmailReport(request: IEmailReportRequest): JQueryDeferred<Data.IResponse<any>> {
    return Util.callReportService("/api/ReportData/EmailReport", "POST", request);
}

export function EmailReportToDefaultRecipients(taskID: number): JQueryDeferred<Data.IResponse<any>> {
    return Util.callReportService(`/api/ReportData/EmailReportToDefaultRecipients/${taskID}`, "POST", null);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/reportData.ts